<svg
  class="sparkline"
  [class.sparkline--blue]="variant === 'blue'"
  [class.sparkline--muted]="variant === 'muted'"
  viewBox="0 0 120 32"
  preserveAspectRatio="none"
  aria-hidden="true"
>
  <polyline [attr.points]="points" />
  @if (endPoint; as end) {
    <circle class="sparkline__end" [attr.cx]="end.x" [attr.cy]="end.y" r="2.5" />
  }
</svg>
